interface GetGscOnboardingStateParams {
    isConnected: boolean;
    isConnectionStatusResolved: boolean;
    isIntegrationsVisited: boolean;
}

export const getGscOnboardingState = ({
    isConnected,
    isConnectionStatusResolved,
    isIntegrationsVisited,
}: GetGscOnboardingStateParams) => {
    return {
        hasMenuNotification: isConnectionStatusResolved && !isConnected && !isIntegrationsVisited,
    };
};
